<template>
    <f-modal
        :visible="isVisible"
        class="alm-action-modal"
        :title="`${localizer.Localize('Delete_PascalCase')} ${currentChangeset?.name ?? ''}`"
        @update:visible="(vis: boolean) => setVisible(vis)"
    >
        <div class="alm-action-modal-body">
            <p>{{ localizer.Localize("LandscapeManagement_Changeset_Deletion_Modal_Text") }}</p>
        </div>
        <template v-slot:footer>
            <div class="flex justify-end">
                <f-button text="Button" type="default" @click="setVisible(false)">
                    {{ localizer.Localize("Cancel_PascalCase") }}
                </f-button>
                <f-button text="Button" type="primary" danger @click="confirmDelete">
                    {{ localizer.Localize("Delete_PascalCase") }}
                </f-button>
            </div>
        </template>
    </f-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Localizer } from "@/api/Localizer";
import { mapActions } from "vuex";

export default defineComponent({
    data() {
        return {
            localizer: new Localizer(this.$store),
        };
    },
    props: {
        isVisible: Boolean,
        currentChangeset: Object,
    },
    methods: {
        ...mapActions("alm", ["deleteChangeset"]),
        setVisible(val: boolean) {
            this.$emit("close", val);
        },
        async confirmDelete() {
            this.$emit("close", false);
            await this.deleteChangeset(this.currentChangeset?.id);
        },
    },
});
</script>

<style scoped>
.alm-action-modal-title {
    display: flex;
    align-items: center;
    padding-left: 16px;
}

.alm-action-modal-title h3 {
    margin-bottom: 0;
}

.alm-action-modal-body {
    padding: 16px;
}
</style>

<style>
.alm-action-modal .ant-modal-content {
    height: 300px;
    display: flex;
    flex-direction: column;
    overflow: auto;
}

.alm-action-modal .ant-modal-footer {
    padding: 16px;
    border-top: solid 1px var(--accent-color3);
}

.alm-action-modal .ant-modal-body {
    flex-grow: 1;
    overflow-y: auto;
}
</style>
